"use strict";

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
}); //================================================================ 

/** @module std.base */
//================================================================

var _MapTree_1 = require("./_MapTree");

var uid_1 = require("../../functional/uid");
/**
 * @hidden
 */


var _MultiMapTree =
/** @class */
function (_super) {
  __extends(_MultiMapTree, _super);
  /* ---------------------------------------------------------
      CONSTRUCTOR
  --------------------------------------------------------- */


  function _MultiMapTree(source, comp) {
    return _super.call(this, source, comp, function (x, y) {
      var ret = comp(x.first, y.first);
      if (!ret && !comp(y.first, x.first)) return uid_1.get_uid(x) < uid_1.get_uid(y);else return ret;
    }) || this;
  }

  _MultiMapTree.prototype.insert = function (val) {
    // ISSUE UID BEFORE INSERTION
    uid_1.get_uid(val);

    _super.prototype.insert.call(this, val);
  };
  /* ---------------------------------------------------------
      FINDERS
  --------------------------------------------------------- */


  _MultiMapTree.prototype._Nearest_by_key = function (key, equal_mover) {
    // NEED NOT TO ITERATE
    if (this.root_ === null) return null; //----
    // ITERATE
    //----

    var ret = this.root_;
    var matched = null;

    while (true) {
      var it = ret.value;
      var my_node = null; // COMPARE

      if (this.key_comp()(key, it.first)) my_node = ret.left;else if (this.key_comp()(it.first, key)) my_node = ret.right;else {
        // EQUAL, RESERVE THAT POINT
        matched = ret;
        my_node = equal_mover(ret);
      } // ULTIL CHILD NODE EXISTS

      if (my_node === null) break;else ret = my_node;
    } // RETURNS -> MATCHED OR NOT


    return matched !== null ? matched : ret;
  };

  _MultiMapTree.prototype.nearest_by_key = function (key) {
    return this._Nearest_by_key(key, function (node) {
      return node.left;
    });
  };

  _MultiMapTree.prototype.upper_bound = function (key) {
    // FIND MATCHED NODE
    var node = this._Nearest_by_key(key, function (node) {
      return node.right;
    });

    if (node === null) // NOTHING
      return this.source().end(); // MUST BE it.first > key

    var it = node.value;
    if (this.key_comp()(key, it.first)) return it;else return it.next();
  };

  return _MultiMapTree;
}(_MapTree_1._MapTree);

exports._MultiMapTree = _MultiMapTree;